import { render } from "./NbaGameCard.vue?vue&type=template&id=1897cafc&scoped=true"
import script from "./NbaGameCard.vue?vue&type=script&lang=js"
export * from "./NbaGameCard.vue?vue&type=script&lang=js"

import "./NbaGameCard.vue?vue&type=style&index=0&id=1897cafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1897cafc"]])

export default __exports__